/**
 * Route paths as a single source of truth.
 *
 * The API registers these and the web client calls them; a typo therefore breaks
 * the build instead of producing a 404 at runtime.
 */
export const API_PREFIX = '/api/v1';
export const ROUTES = {
    health: '/health',
    auth: {
        /** Startet die Anmeldung; leitet zu Google weiter. */
        login: '/auth/login',
        /** Rückleitung von Google mit dem Autorisierungscode. */
        callback: '/auth/callback',
        logout: '/auth/logout',
        /** Wer ist angemeldet? `null`, wenn niemand. */
        me: '/auth/me',
    },
    instruments: {
        list: '/instruments',
        byId: (id) => `/instruments/${id}`,
        search: '/instruments/search',
    },
    positions: {
        list: '/positions',
        create: '/positions',
        byId: (id) => `/positions/${id}`,
        reorder: '/positions/reorder',
        booking: (id) => `/positions/${id}/booking`,
        history: (id) => `/positions/${id}/history`,
    },
    bars: {
        byInstrument: (id) => `/instruments/${id}/bars`,
    },
    drawings: {
        byInstrument: (id) => `/instruments/${id}/drawings`,
        byId: (instrumentId, drawingId) => `/instruments/${instrumentId}/drawings/${drawingId}`,
        /* Die Verbindung zur Stop-Loss-Linie: `POST` knüpft sie, `DELETE` löst sie.
         * Eine eigene Adresse und kein Feld im Änderungsschema, weil dabei mehr
         * geschieht als ein Wert zu wechseln — Farbe, Löschschutz und die
         * Bezugsgröße der täglichen Auswertung hängen daran. */
        link: (instrumentId, drawingId) => `/instruments/${instrumentId}/drawings/${drawingId}/link`,
        /* Zieht die Stop-Loss-Linie auf den Bezugsabstand nach. Am Chart und nicht an
         * einer Zeichnung, weil die Handlung dem Paar gilt — und davon gibt es je
         * Chart höchstens eines. */
        syncStopLoss: (instrumentId) => `/instruments/${instrumentId}/drawings/sync-stop-loss`,
    },
    sync: {
        /* Kein `trigger`: Ein Abgleich lässt sich nicht über HTTP auslösen. Er gehört
         * dem Nachtlauf nach Börsenschluss. */
        state: '/sync/state',
    },
};
//# sourceMappingURL=routes.js.map